"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientContactNote_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Note_1 = require("./Note");
var PatientContactType_1 = require("./PatientContactType");
var PatientContactNote_Factory = /** @class */ (function () {
    function PatientContactNote_Factory() {
    }
    PatientContactNote_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Note: Note_1.Note_Factory.CreateIncoming(model.Note),
            NoteId: model.NoteId,
            PatientContactType: PatientContactType_1.PatientContactType_Factory.CreateIncoming(model.PatientContactType),
            PatientContactTypeId: model.PatientContactTypeId,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    PatientContactNote_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Note: Note_1.Note_Factory.CreateOutgoing(model.Note),
            NoteId: model.NoteId,
            PatientContactType: PatientContactType_1.PatientContactType_Factory.CreateOutgoing(model.PatientContactType),
            PatientContactTypeId: model.PatientContactTypeId,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return PatientContactNote_Factory;
}());
exports.PatientContactNote_Factory = PatientContactNote_Factory;
